import React, { useState, useEffect } from "react";
import './Show.css'
import Furioos from './Furioos';
import Sidepanel from './Sidepanel';
import TwitchPlayer from './TwitchPlayer';
import { Tab, Tabs, TabList, TabPanel } from 'react-tabs';
import { useAuth0 } from "@auth0/auth0-react";
import { useParams } from "react-router-dom";
import API from '../API';
import AppHeader from "./AppHeader";
import IVSPlayer from "./IVSPlayer";
import RegionSelectionModal from "./RegionSelectionModal";
import ClientSelectionModal from "./ClientSelectionModal";
import DesktopClientLoadingModal from "./DesktopClientLoadingModal";
import DesktopClientInstallModal from "./DesktopClientInstallModal";
import WelcomeToDesktopBeta from "./WelcomeToDesktopBeta";

const Show = ({ wallets, setWallets }) => {
    const [showClientSelectionModal, setShowClientSelectionModal] = useState(false);
    const [showDesktopClientLoadingModal, setShowDesktopClientLoadingModal] = useState(false);
    const [showDesktopClientInstallModal, setShowDesktopClientInstallModal] = useState(false);
    const [showWelcomeToDesktopBeta, setShowWelcomeToDesktopBeta] = useState(false);
    const [showFurioos, setShowFurioos] = useState(false);
    const [accessToken, setAccessToken] = useState(null);
    const { isAuthenticated, isLoading, getAccessTokenSilently } = useAuth0();
    const [show, setShow] = useState(null);
    const [sidePanelTabsIndex, setSidePanelTabsIndex] = useState(1);
    const { show_id } = useParams();
    const [deeplink, setDeeplink] = useState("");
    const isWindowsOS = window.navigator.platform.toLowerCase().includes("win");

    useEffect(() => {
        async function getShow() {
            var accessToken;
            if (isAuthenticated) {
                accessToken = await getAccessTokenSilently({
                    audience: process.env.REACT_APP_AUTH0_AUDIENCE,
                    scope: "ffclient:play",
                });
                setAccessToken(accessToken);
            }
            const response = await API.getActiveEvent(accessToken, show_id);

            if (response.status === 404) {
                window.location.href = '/';
                return;
            }
            
            if (response.status !== 200) {
                console.log(`Error getting event ${show_id}.`);
                return;
            }

            const data = await response.json();
            setShow(data);
        };
        async function getDeeplink() {
            var accessToken;
            if (isAuthenticated) {
                accessToken = await getAccessTokenSilently({
                    audience: process.env.REACT_APP_AUTH0_AUDIENCE,
                    scope: "ffclient:play",
                });
                setAccessToken(accessToken);
            }
            const response = await API.getDeeplink();
            
            if (response.status !== 200) {
                console.log(`Error getting deeplink info.`);
                return;
            }

            const data = await response.json();
            const dl = "futurefest://ff_world/?jwt=" + encodeURIComponent(accessToken) + "&playerType=player&jwtMethod=commandline&api_url=" + encodeURIComponent(process.env.REACT_APP_API_URL) + "&fullscreen=false&fullscreen_mode=windowed&gameDownloadUrl=" + encodeURIComponent(data.gameDownloadUrl) + "&freshDownload=false&launcherVersion=" + encodeURIComponent(data.launcherVersion);
            setDeeplink(dl);
        };
        getShow();
        getDeeplink();
    }, [getAccessTokenSilently, isAuthenticated, show_id]);

    function onTabChanged(index, lastIndex, event) {
        setShowFurioos(false);
        setShowWelcomeToDesktopBeta(false);
        setShowClientSelectionModal(false);
        setShowDesktopClientLoadingModal(false);
        setShowDesktopClientInstallModal(false);
        if (index === 0) {
            setSidePanelTabsIndex(1);
        }
    }

    if (isLoading) {
        return <div>Loading ...</div>;
    }

    return isAuthenticated && show && (
        <Tabs className="navigation" selectedTabClassName="navigation_tab--selected tablink-active" selectedTabPanelClassName="navigation_tab-panel--selected" onSelect={onTabChanged} defaultIndex="0">
            <AppHeader wallets={wallets} setWallets={setWallets}>
            { isAuthenticated && 
                <span>
                <TabList className="navigation_tabs">
                    <Tab className="ff-links enter-world-button navigation_tab tablink">Enter World</Tab>
                    |
                    <Tab className="ff-links navigation_tab tablink">Livestream</Tab>
                </TabList>
                </span>
            }
            </AppHeader>
            <div className="stream-box">
                <TabPanel className="navigation_tab-panel">
                    <div className="enter-world-container">
                        <RegionSelectionModal callback={() => {
                            if (isWindowsOS) {
                                setShowClientSelectionModal(true);
                            } else {
                                setShowClientSelectionModal(false);
                                setShowFurioos(true); 
                            }
                        }} />
                        <ClientSelectionModal showClientSelectionModal={showClientSelectionModal} setShowClientSelectionModal={setShowClientSelectionModal} accessToken={accessToken} callback={ () => setShowDesktopClientLoadingModal(true)} furioosCallback={ () => setShowFurioos(true) } deeplink={deeplink} />
                        <DesktopClientLoadingModal showDesktopClientLoadingModal={showDesktopClientLoadingModal} setShowDesktopClientLoadingModal={setShowDesktopClientLoadingModal} callback={ () => setShowDesktopClientInstallModal(true)} enterWorldCallback={ () => setShowWelcomeToDesktopBeta(true) } accessToken={accessToken} deeplink={deeplink} />
                        <DesktopClientInstallModal showDesktopClientInstallModal={showDesktopClientInstallModal} setShowDesktopClientInstallModal={setShowDesktopClientInstallModal} accessToken={accessToken} callback={ () => setShowWelcomeToDesktopBeta(true) } deeplink={deeplink} />
                        { showWelcomeToDesktopBeta && <WelcomeToDesktopBeta accessToken={accessToken} deeplink={deeplink} /> }
                        { showFurioos && <Furioos furioosShareLinkId={show.furioos_id} /> }
                    </div>
                </TabPanel>
                <TabPanel className="navigation_tab-panel">
                    { show.stream_url && <IVSPlayer stream_url={show.stream_url} /> }
                    { !show.stream_url && show.twitch_channel_name && <TwitchPlayer channel={show.twitch_channel_name} height="100%" width="100%" /> }
                </TabPanel>
                <Sidepanel wallets={wallets} setWallets={setWallets} twitch_channel={show.twitch_channel_name} sidePanelTabsIndex={sidePanelTabsIndex} setSidePanelTabsIndex={setSidePanelTabsIndex} />
            </div>
        </Tabs>
    );
};

export default Show;
